import { render, staticRenderFns } from "./PlateTextMoreItem.vue?vue&type=template&id=f3a1f0b6"
import script from "./PlateTextMoreItem.vue?vue&type=script&lang=js"
export * from "./PlateTextMoreItem.vue?vue&type=script&lang=js"
import style0 from "./PlateTextMoreItem.vue?vue&type=style&index=0&id=f3a1f0b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports